import React, { useEffect, useState } from "react";
import "./index.css"
import { ReactComponent as LeftArrow } from "../../../assets/svg/leftArrow.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/svg/downloadIcon.svg";
import { ReactComponent as InfoIcon } from "../../../assets/svg/infoIcon.svg";
import { Button, Popover, Table } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { AuditParams } from "../auditHistory/auditInterface";
import { useToast } from "../../../helpers/commonFunction";
import { Http } from "../../../helpers/axois";
import moment from "moment";
import { Spinner } from "../../../helpers/commonUi";
import { useSelector } from "react-redux";
import NoData from "../../apps/NoData";
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
const ExtensionList: any = {
    "auditHistory": "csv"
}
const TypeList: any = {
    "auditHistory": "Audit History"
}
const StatusList: any = {
    "pending": "Pending",
    "success": "Success",
    "failed": "Failed"
}
const QueryList: any = {
    sort: "Sort",
    startDate: "Start Date",
    endDate: "End Date",
    conditions: "Conditions"
}
export const Downloads = () => {
    const [downloads, setDownloads] = useState<any>(null)
    const { ErrorToast, SuccessToast } = useToast();
    const history = useHistory()
    const { orgId }: AuditParams = useParams()
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    var canViewDownloads = orgPermissions.includes('audit.View')
    useEffect(() => {
        getDownloads()
    }, [])
    const columns = [
        {
            title: 'Type',
            dataIndex: 'exportedfrom',
            key: 'exportedfrom',
        },
        {
            title: 'Created By',
            dataIndex: 'createdby',
            key: 'createdby',
        },
        {
            title: 'Created Date',
            dataIndex: 'createdat',
            key: 'createdat',
        }, {
            title: 'TimeTaken',
            dataIndex: 'timeTaken',
            key: 'timeTaken',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
        }

    ]
    const handleDownload = async (fileUrl: string, exportedFrom: string) => {
        const data = {
            "expTimeInMinutes": 30,
            "urlList": {
                "url": fileUrl
            }
        }
        Http.post(`/audit/signed-url/?orgId=${orgId}`, data).subscribe((res: any) => {
            SuccessToast("Download in progress")
            const link = document.createElement("a");
            link.download = `${new Date().getTime()}_a8StudioAuditHistory.${ExtensionList[exportedFrom]}`;
            link.href = res?.url
            document.body.appendChild(link);
            link.click();
            link.remove();

        }, (e: any) => {
            if (e === "Forbidden") {
                canViewDownloads = false
            } else {
                ErrorToast(e?.error)
            }
        })


    };
    const getDownloads = async () => {
        setDownloads(null)
        Http.get(`/downloads/?orgId=${orgId}`).subscribe((res: any) => {
            if (res && res.length > 0) {
                setDownloads(res);
            } else {
                setDownloads([]);
            }

        }, (e: any) => {
            setDownloads([])
            if (e === "Forbidden") {
                canViewDownloads = false
            } else {
                ErrorToast(e?.error)
            }
        })

    };
    return (
        canViewDownloads ? <div className="downloadsContainer">
            {downloads ? <> <div className="header">
                <div className="first-part">
                    <LeftArrow style={{ cursor: "pointer" }} onClick={() => history.push(`/organization/${orgId}/audit`)} />
                    <div className="title">Downloads</div>
                </div>
                <div>
                    <Button className="refresh-button" onClick={() => getDownloads()}>Refresh</Button>
                </div>
            </div>
                <div className="content">
                    <Table
                        data-test-id="table"
                        rowKey="uid"
                        columns={columns}
                        scroll={{ y: 'calc(100vh - 225px)' }}
                        className="override-table-container"
                        style={{ width: '100%' }}
                        dataSource={
                            downloads &&
                            downloads.map((page: any) => {
                                const date1 = moment(page?.createdat, 'YYYY-MM-DD HH:mm:ss');
                                const date2 = moment(page?.endedat, 'YYYY-MM-DD HH:mm:ss');
                                const timeDifferenceInMilliseconds = date2.diff(date1);
                                const duration = moment.duration(timeDifferenceInMilliseconds);
                                const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
                                const minutes = duration.minutes().toString().padStart(2, '0');
                                const seconds = duration.seconds().toString().padStart(2, '0');
                                const formattedDifference = `${hours}:${minutes}:${seconds}`;
                                const content = (
                                    <div style={{ maxHeight: "400px", overflowY: "auto", fontSize: "13px" }}>
                                        <div style={{ display: "flex", marginBottom: "5px" }}>
                                            <div style={{ width: "25%", fontWeight: 600, textTransform: "uppercase", color: "#5e6885" }}>Name</div>
                                            <div style={{ fontWeight: 600, width: "75%", textTransform: "uppercase", color: "#5e6885" }}>Value</div>
                                        </div>
                                        <div style={{ borderBottom: "1px solid #D9D9D9", marginBottom: "5px" }}></div>
                                        {Object.keys(page?.query).map((key) => {
                                            return <div style={{ display: "flex", marginBottom: "6px" }}>
                                                <div style={{ width: "25%", color: "#626771" }}>{QueryList[key]}</div>
                                                <div style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                                    {key == "conditions" ? page?.query[key]?.length > 0 ? page?.query[key].map((q: any) => <div className="desc">
                                                        <div className="first-part" title={q.key}>{q.key}</div>
                                                        <div className="second-part" title={q.value}>{q.value}</div>
                                                    </div>) : <div>-</div>
                                                        : <div style={{ width: "75%", color: "#10002E" }}>{(key==="startDate"|| key==="endDate" ) ? moment(page?.query[key]).format("D MMM YYYY") +
                                                            ", " +
                                                            moment(page?.query[key]).local().format("HH:mm"): page?.query[key]}</div>}</div>

                                            </div>
                                        })}
                                    </div>
                                );
                                return {
                                    "createdat": (
                                        <div className="createdat">
                                            {page.createdat
                                                ? moment(page.createdat).format("D MMM YYYY") +
                                                ", " +
                                                moment(page.createdat).local().format("HH:mm")
                                                : "_"}
                                        </div>
                                    ),
                                    "exportedfrom": (
                                        <div>
                                            <div className="createdat">{page?.exportedfrom ? TypeList[page?.exportedfrom] : "-"}</div>
                                        </div>
                                    ),
                                    "action": (
                                        <div className="actions"
                                        >
                                            <div style={{ cursor: "pointer" }} > {page.url && <DownloadIcon onClick={() => {
                                                handleDownload(page?.url, page?.exportedfrom)
                                            }} />}
                                                <Popover overlayClassName="info-popover" className="info-popover" placement="left" content={content} title="Query" trigger="click">
                                                    <InfoIcon style={{ marginLeft: page.url ? "6px" : "24px" }} />
                                                </Popover>

                                            </div>
                                        </div>
                                    ),
                                    "status": (
                                        <div>
                                            <div className="createdat" style={{ color: page?.status == "success" ? "green" : page?.status === "pending" ? "orange" : "red" }}>{page?.status ? StatusList[page?.status] : "_"}</div>
                                        </div>
                                    ), "createdby": (
                                        <div>
                                            <div className="createdat">{page?.createdby || "_"}</div>
                                        </div>
                                    ),
                                    "timeTaken": (
                                        <div className="createdat">
                                            {page?.endedat
                                                ? formattedDifference
                                                : "_"}
                                        </div>
                                    ),
                                };
                            })
                        }
                        pagination={false}
                    />
                </div></> : <Spinner />}
        </div> : <NoData
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access'
            noButton={true}
        />
    )
}